var scope_0 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/10fc416bdc4eb2b511f6ef70c5bc42d8.js').default;
var scope_1 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/23f58de82d163a2ecdebc3d6703a3097.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    